import React from 'react'

const AddCustomerContainer = () => {
  return (
    <div>AddCustomerContainer</div>
  )
}

export default AddCustomerContainer